import { useNavigate } from "react-router-dom";
import * as I from "../components/icons";
import { useTipProiect } from "../components/rol";
import { useT } from "../i18n";
import type { Cheie } from "../i18n";
import type { TipProiect } from "../api";

// Bara de pași: traseul de PORNIRE al unui proiect, nu meniul lui — de asta
// apare DOAR în secțiunea de dosar. Odată ce există soluții, navigarea se face
// din rail, iar o a doua bară de navigare peste board ar pune două meniuri pe
// același ecran.
//
// O componentă, nu markup copiat pe fiecare ecran: pasul curent scris de mână
// pe fiecare pagină e felul în care două ecrane ajung să se creadă amândouă
// pasul 2.
//
// PAȘII SUNT AI TIPULUI DE PROIECT. Cel complet pornește din actele terenului
// și merge prin teren, temă și fațadă până la soluții. Terenul și tema sunt doi
// pași, nu unul: «ce lot e» iese din acte și se corectează, «ce se construiește
// pe el» e decizia beneficiarului. Fațada e pasul ei, fiindcă se alege cu
// ochii, pe imagini, și cere tot ecranul; de acolo pornește generarea.
//
// Proiectul de structură pornește dintr-o arhitectură gata făcută, deci n-are
// lot de desenat, temă de scris sau fațadă de ales: dosarul cu planșele și
// studiul, arhitectura importată din ele, apoi soluțiile structurii.
export type Pas = { cheie: string; titlu: Cheie };

export const PASI: Record<TipProiect, Pas[]> = {
  complet: [
    { cheie: "dossier", titlu: "pasi.dosar" },
    { cheie: "location", titlu: "pasi.localizare" },
    { cheie: "brief", titlu: "pasi.tema" },
    // VOLUMETRIA (Cătălin, 8.10.2026): schița de volume pe teren, între temă și
    // fațadă — pasul ei, ca omul să poată lăsa motorul să propună sau să deseneze.
    { cheie: "volumetrie", titlu: "pasi.volumetrie" },
    { cheie: "facade", titlu: "pasi.fatada" },
    { cheie: "solutii", titlu: "pasi.solutii" },
  ],
  structura: [
    { cheie: "dossier", titlu: "pasi.proiect_arhitectura" },
    { cheie: "arhitectura", titlu: "pasi.arhitectura_importata" },
    { cheie: "solutii", titlu: "pasi.solutii" },
  ],
};

export function Pasi({ pid, activ }: { pid: string; activ: string }) {
  const nav = useNavigate();
  const t = useT();
  const tip = useTipProiect();
  // Până se știe tipul, bara stă goală la înălțimea ei: pașii proiectului de
  // structură nu trebuie să clipească întâi ca cei cinci ai celui complet.
  if (!tip) return <div className="pasi" aria-hidden="true" />;
  const pasi = PASI[tip];
  const iActiv = pasi.findIndex((p) => p.cheie === activ);
  return (
    <div className="pasi">
      {pasi.map((p, i) => {
        const facut = i < iActiv;
        const acum = i === iActiv;
        const titlu = t(p.titlu);
        return (
          <span key={p.cheie} style={{ display: "inline-flex", alignItems: "center", gap: 14 }}>
            {i > 0 && <span className={`pas-linie ${i <= iActiv ? "gata" : ""}`} />}
            <button className={`pas ${acum ? "on" : facut ? "gata" : ""}`}
                    disabled={acum} title={titlu}
                    onClick={() => nav(`/p/${pid}/${p.cheie}`)}>
              <span className="pas-nr">{facut ? <I.Bifa size={13} /> : i + 1}</span>
              <span>{titlu}</span>
            </button>
          </span>
        );
      })}
    </div>
  );
}

/** Pașii unui tip, de CITIT: pe ecranul care creează proiectul, ca omul să
 *  știe de la început cât e drumul. Nimic nu se apasă — proiectul nu există
 *  încă, deci n-ai unde merge. */
export function PasiDeCitit({ tip }: { tip: TipProiect }) {
  const t = useT();
  return (
    <ol className="pasi pasi-mici" aria-label={t("proiect_nou.urmeaza")}>
      {PASI[tip].map((p, i) => (
        <li key={p.cheie} className={`pas ${i === 0 ? "on" : ""}`}>
          {i > 0 && <span className="pas-linie" aria-hidden="true" />}
          <span className="pas-nr">{i + 1}</span>
          <span>{t(p.titlu)}</span>
        </li>
      ))}
    </ol>
  );
}
